import { render, staticRenderFns } from "./EditRadioButtons.vue?vue&type=template&id=65aa2428&scoped=true"
import script from "./EditRadioButtons.vue?vue&type=script&lang=ts"
export * from "./EditRadioButtons.vue?vue&type=script&lang=ts"
import style0 from "./EditRadioButtons.vue?vue&type=style&index=0&id=65aa2428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa2428",
  null
  
)

export default component.exports